import {attr, Component, handler} from "../Component";
import {element} from "../CustomElement";
import MetadataService from "../../services/MetadataService";
import {inject} from "../../services/di";
import {slugify} from "../../services/LinkService";

export interface FlyerItemDetails {
	flyerItemDetails: string;
}

@element("flipp-flyer-item-structure-data")
export class FlyerItemStructureData extends Component<FlyerItemDetails, {}> {

	@attr flyerItemDetails: string;

	@inject metadataService: MetadataService;

	render() {
		const flyerItemDetails = JSON.parse(this.flyerItemDetails);
		const {id, brand, name, imageUrl, description, currentPrice, validTo} = flyerItemDetails;
		const itemUri = this.metadataService.getItemLink(id);
		return <div class="structure-data">
			<div itemtype="http://schema.org/Product" itemscope>
			<meta itemprop="name" content={name ? name : ""} />
			<link itemprop="image" href={imageUrl ? imageUrl : ""} />
					<meta itemprop="description" content={description ? description : ""} />
					<div itemprop="offers" itemtype="http://schema.org/Offer" itemscope>
						<link itemprop="url" href={(itemUri && name) ? `https://flipp.com${itemUri}-${slugify(name)}` : ""} />
						<meta itemprop="availability" content="https://schema.org/InStock" />
						<meta itemprop="price" content={currentPrice ? currentPrice : ""} />
						<meta itemprop="priceValidUntil" content={validTo ? validTo : ""} />
					</div>
							<div itemprop="brand" itemtype="http://schema.org/Thing" itemscope>
							<meta itemprop="name" content={brand ? brand : ""} />
							</div>

			</div>
			</div>;
	}
}
